exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-pages-___privacy__mainText___2tOSF{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___privacy__privacyBackround___H7COf{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___privacy__privacyBackround___H7COf{padding:30px}}.src-components-styles-pages-___privacy__privacyBackround___H7COf p{text-align:justify;padding-bottom:10px}@media (max-width:991px){.src-components-styles-pages-___privacy__tableResponsive___3ib-F{overflow-x:scroll;width:100%}}.src-components-styles-pages-___privacy__accordion___zxN6X{cursor:pointer;color:#000;font-size:15px;padding-top:3px;width:100%;text-align:left}.src-components-styles-pages-___privacy__detailColumn___2jtw7{max-width:200px}", ""]);

// exports
exports.locals = {
	"mainText": "src-components-styles-pages-___privacy__mainText___2tOSF",
	"privacyBackround": "src-components-styles-pages-___privacy__privacyBackround___H7COf",
	"tableResponsive": "src-components-styles-pages-___privacy__tableResponsive___3ib-F",
	"accordion": "src-components-styles-pages-___privacy__accordion___zxN6X",
	"detailColumn": "src-components-styles-pages-___privacy__detailColumn___2jtw7"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/pages/privacy.scss
 ** module id = 921
 ** module chunks = 0
 **/